export default {"src":"/_next/static/media/ic_verified_badge.bfe13046.svg","height":14,"width":14};